export const BASE_URL = "https://www.edvia.ai";
export const PHONE_REGEX = /^\+91[6-9]\d{9}$/;

export const HOST_URL = process.env.NEXT_PUBLIC_HOST_URL;

export const openNewTab = (link: string | URL | undefined) => {
	if (typeof link === "string" || link instanceof URL) {
		window.open(link, "_blank");
	}
};

export const checkCountry = "united states";
export const replacedName = "United States of America";

export const allowedDomains = [
	"gmail.com",
	"outlook.com",
	"live.com",
	"msn.com",
	"microsoft.com",
	"hotmail.com",
	"proton.me",
	"icloud.com",
];

export const ImageStorageBucket =
	"https://storage.googleapis.com/edvia_public_bucket";

// =================== STUDENT PROFILE WEIGHTS ========================

// 35.2
export const PersonalInfoFieldsWeights = {
	// studentTitle: 2.4,
	// fatherTitle: 2.4,
	firstName: 3.2,
	middleName: 3.2, // Optional, not counted
	lastName: 3.2,
	gender: 2.4,
	dob: 3.2,
	maritalStatus: 3.2, // Optional
	email: 3.2,
	primaryPhoneNumber: 3.2,
	secondaryPhoneNumber: 0, // Optional
	fatherName: 2.4,
};

// 16.8
export const AddressInfoFieldsWeights = {
	countryName: 2.8,
	pincode: 2.8,
	stateName: 2.8,
	cityName: 2.8,
	addressLine1: 2.8,
	addressLine2: 2.8,
};

// 6
export const PassportInfoFieldsWeights = {
	passportNumber: 2,
	countryOfIssue: 2,
	expiryDate: 2,
};

// 1.6
export const BackgroundInfoFieldsWeights = {
	rejectedVisa: 0.4,
	reason: 0.4,
	gap: 0.4,
	countryName: 0.4,
};

// 11.2
export const QualificationFieldsWeights = {
	qualificationLevel: 1.6,
	qualificationName: 1.6,
	fieldOfStudy: 1.6,
	boardName: 1.6,
	completionYear: 1.6,
	gradeType: 1.6,
	cgpaOrPercentageValue: 1.6,
};

// 10.8
export const EnglishTestFieldsWeights = {
	testName: 1.2,
	listening: 1.2,
	reading: 1.2,
	speaking: 1.2,
	writing: 1.2,
	overall: 1.2,
	testIdentificationNumber: 1.2,
	validTillDate: 1.2,
	testDate: 1.2,
};

// 6.4
export const AcademicTestFieldsWeights = {
	testName: 0.8,
	verbalScore: 0.8,
	quantScore: 0.8,
	analyticalScore: 0.8,
	overallScore: 0.8,
	testIdentificationNumber: 0.8,
	validTillDate: 0.8,
	testDate: 0.8,
};

export const CoursesCardsRemark =
	"Fee details are indicative and may vary. Exact tuition and charges will be in your official offer letter.";

export const ConstructorUniversityId = "f9765650-31d2-4b84-b3c4-703223f0e4a5";

export const DefaultMetaImage = "/assets/metaImages/default.png";
